import { Instance } from 'mobx-state-tree';
import { WebhookTestResultDtoModelBase } from './WebhookTestResultDtoModel.base';

/* The TypeScript type of an instance of WebhookTestResultDtoModel */
export interface WebhookTestResultDtoModelType extends Instance<typeof WebhookTestResultDtoModel.Type> {}

/* A graphql query fragment builders for WebhookTestResultDtoModel */
export { selectFromWebhookTestResultDto, webhookTestResultDtoModelPrimitives, WebhookTestResultDtoModelSelector } from './WebhookTestResultDtoModel.base';

/**
 * WebhookTestResultDtoModel
 */
export const WebhookTestResultDtoModel = WebhookTestResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
